import React from "react";
import { educationData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import { GraduationCap, BookOpen, Briefcase } from "lucide-react";

const eduIconMap = {
  briefcase: Briefcase,
  graduation: GraduationCap,
  book: BookOpen,
};

const Education = () => {
  return (
    <section id="education" className="py-14 lg:py-20 bg-slate-50/50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12 lg:mb-16">
          <p className="text-sm font-medium text-teal-600 tracking-wide uppercase mb-2">
            Academic Background
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Education
          </h2>
          <p className="mt-3 text-slate-500 leading-relaxed">
            A strong academic foundation supporting professional expertise in supply chain management and leadership.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {educationData.map((edu) => {
            const Icon = eduIconMap[edu.icon] || GraduationCap;
            return (
              <Card
                key={edu.id}
                className="group border border-slate-100 bg-white hover:border-teal-100 hover:shadow-md transition-all duration-300"
              >
                <CardContent className="p-6">
                  <div className="w-11 h-11 rounded-xl bg-slate-50 group-hover:bg-teal-50 flex items-center justify-center text-slate-400 group-hover:text-teal-600 transition-all duration-300 mb-4">
                    <Icon size={22} />
                  </div>
                  <h3 className="text-base font-semibold text-slate-900 leading-snug">
                    {edu.degree}
                  </h3>
                  <p className="text-sm text-teal-600 font-medium mt-1">
                    {edu.field}
                  </p>
                  <div className="mt-4 pt-4 border-t border-slate-50">
                    <p className="text-sm text-slate-600">{edu.school}</p>
                    <p className="text-xs text-slate-400 mt-0.5">{edu.year}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
